import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled, { css } from 'styled-components';
import Typography from '@material-ui/core/Typography';
import AccountIcon from 'mdi-react/AccountIcon';
import PhoneIcon from 'mdi-react/PhoneIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import MapMarkerIcon from 'mdi-react/MapMarkerIcon';
import type { WWWCompanyDocument } from '../../common/documents/WWWCompanyDocument';
import { Header } from '../Header';
import { Banner } from '../Banner';
import { PremiumIcon } from '../PremiumIcon';
import { useCompanyDictionary } from './CompanyDictionary';
import { CompanyEditDialogContent } from './CompanyEditDialog';
import { EditContactPerson } from './EditContactPerson';
import { Skeleton, StyledLabel } from './CompanyFieldAndHelpers';
import { Grid, Column, Item, Spacer } from './CompanyGrid';
import { EditLocation } from './EditLocation';
import { Color, mediaQuery } from '../Theme';
import { EditReference } from './EditReference';

const Styled = {
  Row: styled.div`
    display: flex;
    flex-wrap: wrap;

    .MuiTypography-h5 {
      font-size: 1.5rem;
    }

    p {
      margin: 0.2rem 0;
      white-space: pre-line;
    }
  `,
  Address: styled.div`
    display: flex;
    margin-top: 1rem;
    width: 33.33%;

    > div:last-child {
      flex: 1;
      margin-left: 1rem;

      p {
        display: flex;
        align-items: center;

        &:first-of-type {
          margin-bottom: 0.4rem;
        }

        svg {
          margin-right: 0.6rem;
          width: 16px;
          height: 16px;
          opacity: 0.5;
        }
      }
    }

    ${mediaQuery.medium(css`
      width: 50%;
    `)}

    ${mediaQuery.small(css`
      width: 100%;
    `)}
  `,
  Contact: styled.div`
    display: flex;
    margin-top: 1rem;
    width: 33.33%;

    > div:last-child {
      flex: 1;
      margin-left: 1rem;

      p {
        display: flex;
        align-items: center;

        &:first-of-type {
          margin-bottom: 0.4rem;
        }

        svg {
          margin-right: 0.6rem;
          width: 16px;
          height: 16px;
          opacity: 0.5;
        }
      }
    }

    ${mediaQuery.medium(css`
      width: 50%;
    `)}

    ${mediaQuery.small(css`
      width: 100%;
    `)}
  `,
  Image: styled.div`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background-color: ${Color.background};

    svg {
      color: ${Color.disabled};
    }
  `,
};

const EditContent = styled.div`
  display: flex;
  flex-direction: column;

  > div {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
  }

  > button {
    margin-bottom: 0.5rem;
  }
`;

export const CompanyReferenceEdit: CompanyEditDialogContent = ({ company, openSelect, closeSelect }) => {
  const dictionary = useCompanyDictionary();

  return (
    <>
      <Header>{dictionary.references}</Header>

      <EditContent>
        <StyledLabel>{dictionary.references}</StyledLabel>
        <EditReference parentTitle={dictionary.references} onOpen={openSelect} onClose={closeSelect} />
      </EditContent>
    </>
  );
};
